import authReducer from "./auth";
import layoutReducer from "./layout";
import paginationReducer from "./pagination";
import snackBar from "./snackbar";
import loader from "./loader";
import userReducer from "./userSlice";
import employeeReducer from "./employeeSlice";
import branchReducer from "./branchSlice";
import departmentReducer from "./departmentSlice";
import designationReducer from "./designationSlice";
import roleReducer from "./roleSlice";
import holidayReducer from "./holidaySlice";
import shiftsReducer from "./shiftsSlice";
import commonReducer from "./commonSlice";
import loginReducer from "./login";
import NoAuthReducer from "./noAuthSlice";
import urlExpiredSlice from "./expiredUrlSlice";
import moreSettingSlice from "./moreSettings";
import liveAttendanceSlice from "./liveAttendanceSlice";
import dailyAttendanceSlice from "./dailyAttendanceSlice";
import monthAttendanceSlice from "./monthAttendanceSlice";
import auditSlice from "./auditSlice";
import payrollSlice from "./payrollSlice";
import incentiveSlice from "./incentiveSlice";
import reimburseSlice from "./reimbursementSlice";
import salarySlice from "./salarySlice";
import uploadFileSlice from "./uploadFiles";
import attendanceSlice from "./attendanceSlice"
import paymentHistorySlice from "./paymentHistory"
import dashboardReducer from "./dashboardSlice"
import TaxSlice from "./taxSlice";
import themeSliceRducer from "./themeSlice"
import ancemntSlice from "./announcementSlice"
import leaveSlice from "./leaveSlice"
import TdsSlice from "./tdsSlice";


export const reducer = {
  layout: layoutReducer,
  auth: authReducer,
  pagination: paginationReducer,
  snackBar: snackBar,
  loader: loader,
  dashboard: dashboardReducer,
  user: userReducer,
  employee: employeeReducer,
  branch: branchReducer,
  department: departmentReducer,
  designation: designationReducer,
  roles: roleReducer,
  holiday: holidayReducer,
  shift: shiftsReducer,
  common: commonReducer,
  login: loginReducer,
  noAuth: NoAuthReducer,
  expiredUrl: urlExpiredSlice,
  moreSettings: moreSettingSlice,
  liveAttendance: liveAttendanceSlice,
  dailyAttendance: dailyAttendanceSlice,
  monthAttendance: monthAttendanceSlice,
  audit: auditSlice,
  payroll: payrollSlice,
  incentive: incentiveSlice,
  reimburse: reimburseSlice,
  salary: salarySlice,
  fileUpload: uploadFileSlice,
  attendance: attendanceSlice,
  paymentHistory: paymentHistorySlice,
  tax: TaxSlice,
  theme: themeSliceRducer,
  announce: ancemntSlice,
  leave: leaveSlice,
  tds:TdsSlice
};
